import { SvgIcon } from "./SvgIcon";
import { v4 as uuidv4 } from "uuid";

function IconComponent(props: any) {
  const uid = uuidv4();

  return (
    <SvgIcon {...props} viewBox="0 0 12 12">
      <g clipPath={`url(#clip${uid})`}>
        <path d="M0.5 4.99992H11.5C11.599 5.0001 11.6959 4.97087 11.7783 4.91594C11.8606 4.86101 11.9249 4.78286 11.9628 4.69138C12.0007 4.59991 12.0106 4.49924 11.9912 4.40213C11.9719 4.30502 11.9241 4.21585 11.854 4.14592L7.854 0.145918C7.78407 0.0758114 7.6949 0.0280469 7.59779 0.00868009C7.50068 -0.0106867 7.40001 -0.000783589 7.30854 0.0371339C7.21706 0.0750515 7.13891 0.139276 7.08398 0.221665C7.02905 0.304054 6.99982 0.400898 7 0.499918V2.99992H0.5C0.367392 2.99992 0.240215 3.0526 0.146447 3.14636C0.0526784 3.24013 0 3.36731 0 3.49992L0 4.49992C0 4.63253 0.0526784 4.7597 0.146447 4.85347C0.240215 4.94724 0.367392 4.99992 0.5 4.99992Z" />
        <path d="M11.5009 7H0.500895C0.401874 6.99982 0.305031 7.02905 0.222642 7.08398C0.140252 7.13891 0.076028 7.21706 0.0381105 7.30854C0.000192974 7.40001 -0.00971013 7.50068 0.00965666 7.59779C0.0290234 7.6949 0.0767879 7.78407 0.146895 7.854L4.14689 11.854C4.19341 11.9004 4.24862 11.9372 4.30936 11.9622C4.37011 11.9873 4.43519 12.0001 4.5009 12C4.56647 12.0003 4.63142 11.9873 4.6919 11.962C4.78333 11.9242 4.8615 11.8601 4.9165 11.7779C4.97151 11.6957 5.00088 11.5989 5.0009 11.5V9H11.5009C11.6335 9 11.7607 8.94732 11.8544 8.85355C11.9482 8.75979 12.0009 8.63261 12.0009 8.5V7.5C12.0009 7.36739 11.9482 7.24022 11.8544 7.14645C11.7607 7.05268 11.6335 7 11.5009 7Z" />
      </g>
      <defs>
        <clipPath id={`clip${uid}`}>
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default IconComponent;
